module.exports = __webpack_public_path__ + "img/temperature_white.e65d31ed.svg";